export const mainLeftNavigationStyles = `
.qba-root {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 60;
}
.qba-panel {
  position: relative;
  height: 100%;
  font-size: var(--fs-lg);
  color: var(--catchup-gray-400);
  /* Animate width only (not all, which dragged the heavy box-shadow into the
     transition). Shorter + will-change keeps the expand smooth. */
  transition: width 260ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: width;
  z-index: 0;
}
.qba-panel-full {
  width: var(--w-catchup-main-left-navigation);
}
/* full mode: inset the option list so the selected/hover pill's slide-out tab
   (translateX + scale + shadow) shows in full instead of being clipped at the
   scroll's right edge (overflow-y:auto also clips x) */
.qba-panel-full .qba-option-list {
  padding-left: 6px;
  padding-right: 18px;
}
.qba-panel-icon-only {
  width: var(--w-catchup-main-left-navigation-icon-only);
}
/* icon-only: more breathing room in the narrow rail so the selected pill
   (and its shadow) is centered and never clipped by the scroll's edge */
.qba-panel-icon-only .qba-inner {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.qba-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  border-right: 1px solid rgba(255, 255, 255, 0.30);
  border-top-right-radius: var(--rad-catchup-clock);
  border-bottom-right-radius: var(--rad-catchup-clock);
  /* soft liquid glass — very transparent, lets the page tint through */
  background-color: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(18px) saturate(165%);
  backdrop-filter: blur(18px) saturate(165%);
  box-shadow:
    inset 1.5px 2.5px 0 -2px rgba(255, 255, 255, 0.85),
    inset -2px -2px 0 -2px rgba(255, 255, 255, 0.6),
    inset 0 0 0 1px rgba(255, 255, 255, 0.12),
    inset -0.5px -1px 6px 0 rgba(15, 72, 89, 0.06),
    8px 0 30px -12px rgba(15, 72, 89, 0.16);
}
.qba-logo-wrapper {
  margin-bottom: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-left: auto;
  margin-right: auto;
}
.qba-logo {
  width: 8rem;
}
.qba-logo-icon {
  width: 2rem;
}
.qba-scroll {
  /* fill the space between logo and footer; scroll ONLY if the items truly
     exceed it — no forced/empty scroll (was height:100% + 100px list padding) */
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.qba-option-list {
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
}
.qba-option {
  display: flex;
  flex-direction: column;
  z-index: 20;
}
.qba-option-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  transform-origin: left center;
  cursor: pointer;
  color: var(--text-muted);
  font-size: var(--fs-lg);
  font-weight: var(--font-weight-medium);
  gap: var(--space-3);
  padding: 9px var(--space-3);
  border-radius: var(--rad-catchup-medium);
  transition:
    transform var(--duration-base) cubic-bezier(0.34, 1.7, 0.5, 1),
    background var(--duration-base) var(--ease-standard),
    color var(--duration-base) var(--ease-standard),
    box-shadow var(--duration-base) var(--ease-standard),
    border-radius var(--duration-base) var(--ease-standard);
}
.qba-option-header-full {
  justify-content: space-between;
}
.qba-option-header-icon-only {
  justify-content: center;
  /* fixed centered square pill: roomy for the 20px icon, fits the rail with
     margin to spare so scale + shadow never clip */
  width: 44px;
  height: 44px;
  padding: 0;
  margin-left: auto;
  margin-right: auto;
  transform-origin: center;
}
.qba-option-header-selected {
  background-image: linear-gradient(180deg, #2c97ab, var(--brand-dark));
  color: var(--catchup-white);
  font-weight: var(--font-weight-bold);
  transform: translateX(10px) scale(1.03);
  border-radius: var(--rad-catchup-medium) var(--rad-catchup-clock)
    var(--rad-catchup-clock) var(--rad-catchup-medium);
  box-shadow: -6px 12px 28px -10px rgba(15, 72, 89, 0.55);
}
.qba-option-header-unselected:hover {
  background-color: rgba(255, 255, 255, 0.22);
  color: var(--brand-dark);
  transform: translateX(10px) scale(1.03);
  border-radius: var(--rad-catchup-medium) var(--rad-catchup-clock)
    var(--rad-catchup-clock) var(--rad-catchup-medium);
  box-shadow:
    inset 1.2px 2px 0 -1.5px rgba(255, 255, 255, 0.9),
    inset -1.5px -1.5px 0 -1.5px rgba(255, 255, 255, 0.55),
    inset 0 0 0 1px rgba(255, 255, 255, 0.18),
    -6px 10px 24px -12px rgba(15, 72, 89, 0.32);
}
.qba-option-header:active {
  transform: translateX(10px) scale(0.98);
}
/* icon-only mode: no horizontal shift so icons stay centered on the rail */
.qba-option-header-icon-only.qba-option-header-unselected:hover {
  transform: scale(1.05);
  border-radius: var(--rad-catchup-medium);
  /* symmetric, compact shadow (no -6px left offset) so it doesn't clip */
  box-shadow: 0 5px 14px -8px rgba(15, 72, 89, 0.32);
}
.qba-option-header-icon-only.qba-option-header-selected {
  transform: scale(1.05);
  border-radius: var(--rad-catchup-medium);
  box-shadow: 0 5px 14px -6px rgba(15, 72, 89, 0.5);
}
.qba-option-header-icon-only:active {
  transform: scale(0.96);
}
.qba-option-icon-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.5rem;
}
.qba-icon-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform var(--duration-base) cubic-bezier(0.34, 1.56, 0.64, 1);
}
.qba-option-header-unselected:hover .qba-icon-wrapper {
  transform: scale(1.18) rotate(-4deg);
}
.qba-option-header-selected .qba-icon-wrapper {
  transform: scale(1.08);
}
.qba-pill-count {
  position: absolute;
  top: -6px;
  right: -8px;
  min-width: 16px;
  height: 1rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  background-color: var(--catchup-red);
  border-radius: var(--rad-catchup-full);
  display: flex;
  align-items: center;
  justify-content: center;
}
.qba-pill-count-text {
  font-size: 10px;
  color: var(--catchup-white);
  font-weight: 600;
  line-height: 1;
}
.qba-pill-dot {
  position: absolute;
  top: 0;
  right: 0;
  width: 0.5rem;
  height: 0.5rem;
  background-color: var(--catchup-red);
  border-radius: var(--rad-catchup-full);
}
.qba-option-label {
  flex: 1 1 0%;
  min-width: 0;
  /* Keep labels on one line while the panel is mid-expand (they were wrapping to
     2 lines at narrow widths, then snapping to 1 — that was the "jank"). */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.qba-option-label-selected {
  color: var(--catchup-white);
}
.qba-arrow {
  height: 1.25rem;
  width: 1.25rem;
}
.qba-suboption-list {
  margin-left: 1rem;
  margin-right: 1rem;
}
.qba-suboption {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  cursor: pointer;
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.qba-suboption-text {
  flex: 1 1 0%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--fs-base);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.qba-suboption-label {
  border-bottom-width: 3px;
  border-bottom-style: solid;
}
.qba-suboption-label-selected {
  border-bottom-color: var(--catchup-blue);
}
.qba-suboption-label-unselected {
  border-bottom-color: var(--catchup-white);
}
.qba-footer {
  margin-top: auto;
  position: relative;
}
.qba-fade {
  position: absolute;
  top: -100px;
  width: 100%;
  height: 100px;
  z-index: 30;
  pointer-events: none;
}
.qba-faq-button {
  cursor: pointer;
  border-radius: var(--rad-catchup-large);
  margin: 0.35rem 0;
  padding: 0.4rem;
  background: linear-gradient(
    135deg,
    rgba(87, 194, 211, 0.18) 0%,
    rgba(126, 87, 194, 0.18) 100%
  );
  border: 1px solid var(--glass-border);
  box-shadow: 0 1px 2px rgba(15, 72, 89, 0.06);
  transition:
    transform 200ms cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 200ms cubic-bezier(0.4, 0, 0.2, 1),
    background 200ms cubic-bezier(0.4, 0, 0.2, 1);
}
.qba-faq-button:hover {
  transform: translateY(-1px);
  box-shadow: var(--glass-float);
  background: linear-gradient(
    135deg,
    rgba(87, 194, 211, 0.28) 0%,
    rgba(126, 87, 194, 0.28) 100%
  );
}
.qba-faq-button-icon-only {
  justify-content: center;
}
.qba-faq-button-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.6rem;
}
.qba-faq-button-full .qba-faq-button-group {
  justify-content: flex-start;
}
.qba-faq-button-icon-only .qba-faq-button-group {
  justify-content: center;
}
.qba-faq-go {
  flex-shrink: 0;
  font-size: var(--fs-xl);
  line-height: 1;
  color: var(--catchup-blue);
  opacity: 0.7;
  transition: transform 200ms cubic-bezier(0.4, 0, 0.2, 1);
}
.qba-faq-button:hover .qba-faq-go {
  transform: translateX(2px);
  opacity: 1;
}
.qba-faq-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: var(--rad-catchup-full);
  background: var(--glass-popover-bg);
  box-shadow:
    inset 0 1px 1px rgba(255, 255, 255, 0.8),
    0 2px 6px -2px rgba(15, 72, 89, 0.25);
}
.qba-faq-emoji {
  font-size: var(--fs-xl);
  line-height: 1;
}
.qba-faq-button-label {
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
  min-width: 0;
}
.qba-faq-label-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--fs-md);
  font-weight: var(--font-weight-bold);
  color: var(--brand-dark);
  line-height: 1.2;
}
.qba-profile-wrap {
  position: relative;
}
.qba-profile {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  column-gap: 0.5rem;
  padding: 0.4rem 0.5rem;
  border: none;
  background-color: transparent;
  font-family: inherit;
  color: inherit;
  text-align: left;
  border-radius: var(--rad-catchup-medium);
  transition: background-color var(--duration-base) var(--ease-standard),
              box-shadow var(--duration-base) var(--ease-standard),
              transform var(--duration-base) var(--ease-standard);
}
/* resting affordance when expanded — a faint glass pill makes it obvious the
   whole row (avatar + name) is tappable and opens "Profilim" */
.qba-profile:not(.qba-profile-icon-only) {
  background-color: rgba(255, 255, 255, 0.10);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.16);
}
.qba-profile:hover {
  background-color: rgba(255, 255, 255, 0.24);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.30);
}
.qba-profile:active {
  transform: scale(0.98);
}
.qba-profile-icon-only {
  justify-content: center;
}
/* Profile popover menu — opens above the avatar trigger (the footer sits at the
   bottom). Glass popover holding Profilim / Profil değiştir / Çıkış as real,
   keyboard-focusable menu items (replaces the old nested switch icon). */
.qba-profile-menu {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  min-width: 210px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px;
  border-radius: var(--rad-catchup-large);
  background: var(--glass-popover-bg);
  -webkit-backdrop-filter: var(--glass-popover-filter);
  backdrop-filter: var(--glass-popover-filter);
  border: 1px solid var(--glass-flat-border);
  box-shadow: var(--glass-popover-shadow);
  z-index: var(--z-dropdown);
}
.qba-menu-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem 0.625rem;
  border: none;
  background-color: transparent;
  border-radius: var(--rad-catchup-medium);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--fs-base);
  font-weight: 600;
  color: var(--text-primary);
  text-align: left;
  transition: background-color var(--duration-base) var(--ease-standard);
}
.qba-menu-item:hover {
  background-color: var(--glass-active-bg);
}
.qba-menu-item-danger {
  color: var(--color-error-text);
}
.qba-menu-item-danger:hover {
  background-color: rgba(226, 91, 91, 0.12);
}
/* Initials avatar + websocket connection status ring (admin-web parity) */
.qba-avatar-wrap {
  position: relative;
  flex-shrink: 0;
}
.qba-avatar {
  width: 38px;
  height: 38px;
  border-radius: var(--rad-catchup-full);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--fs-md);
  font-weight: 800;
  letter-spacing: 0.5px;
  color: var(--catchup-white);
  background: linear-gradient(180deg, var(--catchup-blue-400), var(--catchup-blue-600));
  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.5), 0 4px 10px rgba(15, 137, 156, 0.3);
}
.qba-ws-dot {
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 12px;
  height: 12px;
  border-radius: var(--rad-catchup-full);
  border: 2px solid var(--catchup-white);
  box-sizing: border-box;
}
.qba-ws-connected { background: var(--catchup-green, #3dae72); }
.qba-ws-connecting { background: var(--accent-gold, #f5a623); }
.qba-ws-disconnected { background: var(--catchup-red, #e2574c); }
.qba-ws-ping {
  position: absolute;
  inset: -2px;
  border-radius: var(--rad-catchup-full);
  background: inherit;
  opacity: 0.55;
}
.qba-profile-info {
  flex: 1 1 0%;
  flex-direction: row;
  align-items: center;
}
.qba-profile-name {
  font-weight: 600;
}
.qba-profile-email {
  font-size: var(--fs-md);
  opacity: 0.6;
}
/* personal customized mascot as the profile avatar (full-body, scales with box) */
.qba-mascot-avatar {
  position: relative;
  width: 46px;
  height: 54px;
  flex-shrink: 0;
}
.qba-profile-class {
  font-size: var(--fs-md);
  opacity: 0.65;
}
/* navigation cue — signals the row opens "Profilim" */
.qba-profile-go {
  flex-shrink: 0;
  margin-left: auto;
  font-size: var(--fs-2xl);
  line-height: 1;
  font-weight: 700;
  color: var(--brand-dark);
  opacity: 0.55;
  padding-right: 2px;
  transition: transform var(--duration-base) var(--ease-standard);
}
.qba-profile-go-open {
  transform: rotate(90deg);
}
`;
